/* eslint-disable eqeqeq */
import { instanceOEF, segundaVersaoOEF } from './api'
import moment from 'moment'

export const updateAssinatura = ( idAssinatura, day, isCuradoria, nextdata ) => {
  const idCategoria = [
    {
      'day': 11,
      'id': 9
    },
    {
      'day': 25,
      'id': 3
    }
  ]
  const idIneditos = [
    {
      'day': 11,
      'id': 10
    },
    {
      'day': 25,
      'id': 6
    }
  ]
  const nextDataFormated = moment( nextdata, 'M/YYYY' ).format( 'YYYY-MM' )
  const categoria = isCuradoria ? idCategoria : idIneditos
  const { id } = categoria.find( item => item.day == day )
  const data = {
    'assinatura_id': idAssinatura,
    'ciclo_cobranca': id,
    'data_proxima_renovacao_automatica': `${nextDataFormated}-${day}T00:00:00Z`,
    'renovacao_automatica': true
  }

  instanceOEF.patch( `${segundaVersaoOEF}/assinatura`, data )
}
